var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8333 16.4587H5C3.27667 16.4587 1.875 15.057 1.875 13.3337V6.66699C1.875 4.94366 3.27667 3.54199 5 3.54199H15.8333C17.0975 3.54199 18.125 4.56949 18.125 5.83366V14.167C18.125 15.4312 17.0975 16.4587 15.8333 16.4587ZM5 4.79199C3.96583 4.79199 3.125 5.63283 3.125 6.66699V13.3337C3.125 14.3678 3.96583 15.2087 5 15.2087H15.8333C16.4075 15.2087 16.875 14.7412 16.875 14.167V5.83366C16.875 5.25949 16.4075 4.79199 15.8333 4.79199H5Z",
    fill: "#4C88FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5001 6.875H14.2334C13.4117 6.875 12.6067 7.20917 12.0251 7.79167C11.4342 8.3825 11.1084 9.16667 11.1084 10C11.1084 11.7233 12.5101 13.125 14.2334 13.125H17.5001C17.8451 13.125 18.1251 12.845 18.1251 12.5V7.5C18.1251 7.155 17.8451 6.875 17.5001 6.875ZM16.8751 11.875H14.2334C13.1992 11.875 12.3584 11.0342 12.3584 10C12.3584 9.5 12.5534 9.03 12.9084 8.675C13.2576 8.32583 13.7409 8.125 14.2334 8.125H16.8751V11.875ZM14.6084 9.55833C14.7251 9.675 14.7917 9.83333 14.7917 10C14.7917 10.0833 14.7751 10.1583 14.7417 10.2417C14.7167 10.3167 14.6667 10.3833 14.6084 10.4417C14.4917 10.5583 14.3334 10.625 14.1667 10.625C14.0001 10.625 13.8417 10.5583 13.7251 10.4417C13.6084 10.325 13.5417 10.1667 13.5417 10C13.5417 9.83333 13.6084 9.675 13.7251 9.55833C13.9584 9.325 14.3751 9.325 14.6084 9.55833Z",
    fill: "#4C88FF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.b8504d3ab4f43cd427bcd747bb3fd1e1.svg";
export { ForwardRef as ReactComponent };